import { useMemo } from "react";

import type { IFiltersConfigCategoryItem } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/category";
import type { CategoryFiltersConfig } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import type { OrderedSearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { EMPTY_DESCRIPTION } from "../configs/emptyDescription";
import { appsCategories } from "../configs/filterCategory";
import { useAppsFlowStrategy } from "../context/AppsFlowContext";
import createPlatformFilter from "../models/PlatformFilter/factory";
import useAppsDescriptionQuery from "../queries/useAppsDescriptionQuery";
import { composeAppsFiltersConfig, composeAppsFiltersLockedConfig } from "../utils/composeAppsFiltersConfig";

const PLATFORM_FILTER_ORDER = 290;

const APPS_CATEGORIES_LIST: readonly IFiltersConfigCategoryItem[] = Object.values(appsCategories);

export const useComputeAppsFiltersConfig = (): CategoryFiltersConfig<OrderedSearchFilterInstance> => {
    const isAppsEnabled = salesSettingsHelper.isConsolidatedAppsEnabled;

    const { market } = useAppsFlowStrategy();

    const { data: description } = useAppsDescriptionQuery();

    const platformFilter = useMemo(() => {
        const instance = createPlatformFilter();
        instance.order = PLATFORM_FILTER_ORDER;

        return instance;
    }, []);

    const { filtersList, status } = useMemo(
        () =>
            isAppsEnabled
                ? composeAppsFiltersConfig(platformFilter as OrderedSearchFilterInstance, market, description)
                : composeAppsFiltersLockedConfig(
                      platformFilter as OrderedSearchFilterInstance,
                      market,
                      EMPTY_DESCRIPTION,
                  ),
        [isAppsEnabled, market, description, platformFilter],
    );

    return { filtersList, status, categoriesList: APPS_CATEGORIES_LIST };
};
